import { ReactComponent as EllipsisIcon } from '@assets/components/panel/notification/ellipsis.svg';
import { Center, For, HStack, Icon, Text } from '@chakra-ui/react';
import { Tooltip } from '@components/ui/tooltip';
import { useAppSelector } from '@hooks/redux.hooks';
import useListFormatter from '@hooks/useListFormatter';
import { makeSelectPlatformsNamesByCode } from '@redux/config/config.selectors';
import { getPlatformsCodesFromMarks } from '@utils/common.utils';
import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';

import { Mark } from '@/types/commons/commons.types';

type Props = {
  marks: Mark[];
  isNotificationSelected?: boolean;
};

export function NotificationPlatformList({ marks, isNotificationSelected = false }: Readonly<Props>) {
  const formatList = useListFormatter();
  const platformCodes = getPlatformsCodesFromMarks(marks);
  const selectPlatformNames = useMemo(makeSelectPlatformsNamesByCode, []);
  const platforms = useAppSelector((state) => selectPlatformNames(state, platformCodes), shallowEqual);
  const hasMorePlatform = platforms.length > 5;

  return (
    <HStack maxWidth="100%" gap={0.5}>
      <For each={platforms.slice(0, 5)}>
        {(platform) => (
          <Tooltip key={platform} content={platform}>
            <Text
              paddingX={0.25}
              backgroundColor={isNotificationSelected ? 'neutral.800' : 'neutral.600'}
              textTransform="uppercase"
              lineHeight="18px"
              color="neutral.white"
            >
              {platform.slice(0, 4)}
            </Text>
          </Tooltip>
        )}
      </For>
      {hasMorePlatform && (
        <Tooltip content={formatList(platforms.slice(5))}>
          <Center
            width="15px"
            height="18px"
            backgroundColor={isNotificationSelected ? 'neutral.800' : 'neutral.600'}
            paddingTop="11px"
          >
            <Icon as={EllipsisIcon} width="8px" height="3px" color="neutral.white" />
          </Center>
        </Tooltip>
      )}
    </HStack>
  );
}
